import { get } from "@ember/object"
import Component from "@glimmer/component"
import type { LegacyCardComment, LessonCard } from "@shared/models/card-stack"
import type { Comment } from "@shared/models/comment"
import FindManyAltogether from "cc-frontend/helpers/find-many-altogether"
import { use } from "ember-could-get-used-to-this"

interface Sig {
  Args: {
    card: LessonCard
    showStandardDescriptions: boolean
    showComments: boolean
  }
}

export default class PrintLessonCard extends Component<Sig> {
  @use allComments = new FindManyAltogether(() => [
    "comment",
    this.args.showComments ? get(this.args.card.attributes, "commentIds") : [],
  ])

  get viewableComments(): Comment[] {
    if (get(this.allComments, "content") === null) return []

    return get(this.allComments, "content")!.filter(
      (comment) =>
        comment &&
        !get(comment.attributes, "deletedAt") &&
        comment.meta.permissions.includes("can-view-comment")
    )
  }

  // LEGACY EMBEDDED COMMENTS

  get legacyComments(): LegacyCardComment[] {
    return this.args.card.attributes.comments
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Print:Lesson::Card": typeof PrintLessonCard
  }
}
